
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { CiEdit } from "react-icons/ci";
import { FaPlug } from "react-icons/fa";
import {
  DatePicker,
  Select,
  Button,
  Form,
  Input,
  Checkbox,
  InputNumber
} from "antd";

const ChargerDetailsComponent = ({ chargerDetails, setChargerDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {
  const [form] = Form.useForm();
    const { Option } = Select;  
  

  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(chargerDetails).filter((value) => value !== null)
          .length === Object.values(chargerDetails).length
      ) {
        form.submit();
        setChargerDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setChargerDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
      }
    }
  };
  function getChargerCountFromMatrix(){
    if(chargerDetails){
      return (
      chargerDetails?.connectorMatrix?.[0]?.[0]?.[0] + chargerDetails?.connectorMatrix?.[0]?.[0]?.[1] +
      chargerDetails?.connectorMatrix?.[0]?.[1]?.[0] + chargerDetails?.connectorMatrix?.[0]?.[1]?.[1] + 
      chargerDetails?.connectorMatrix?.[1]?.[0]?.[0] + chargerDetails?.connectorMatrix?.[1]?.[0]?.[1] + 
      chargerDetails?.connectorMatrix?.[1]?.[1]?.[0] + chargerDetails?.connectorMatrix?.[1]?.[1]?.[1] )
    }
    return 0
  }


  return (
    <div className={Styles[`main-div`]}>
      <div className={Styles["location-head-div"]}>
        <div>
          <span>
            {" "}
            {chargerDetails?.isSectionCompleted && isApprover &&  isApproverView && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!chargerDetails?.isSectionCompleted || siteStatus === "Live" || siteStatus === "Pre Live" || approvalStage !== 'PendingApproval'}
                onClick={() => {
                  setChargerDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <CiEdit  
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={chargerDetails}
        disabled={chargerDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false)}
      >
        <Form.Item label="No. of Chargers" name="noOfChargers"
          rules={[{ required: true, message: "Please input no.of chargers!" }]}>
        <InputNumber
          // value={chargerDetails?.noOfChargers}
          onChange={(value) => {
            setChargerDetails((prev) => ({
              ...prev,
              noOfChargers: value,
            }));
          }}
        ></InputNumber>
      </Form.Item>
        <Form.Item label="Res Charger Count" name="resChargerCount"
          rules={[{ required: true, message: "Please input no.of Res chargers!" }]}> 
        <InputNumber
          // value={chargerDetails?.resChargerCount}
          onChange={(value) => {
            setChargerDetails((prev) => ({
              ...prev,
              resChargerCount: value,
            }));
          }}
        ></InputNumber>
      </Form.Item>
        <Form.Item label="Non-Res Charger Count" name="nonResChargerCount"
          rules={[{ required: true, message: "Please input no.of non res chargers!" }]}>
        <InputNumber
          // value={chargerDetails?.nonResChargerCount}
          onChange={(value) => {
            setChargerDetails((prev) => ({
              ...prev,
              nonResChargerCount: value,
            }));
          }}
        ></InputNumber>
      </Form.Item>
        <Form.Item label="Level 2 Charger Count" name="l2ChargerCount"
          rules={[{ required: true, message: "Please input no.of l2 chargers!" }]}>
        <InputNumber
          // value={chargerDetails?.l2ChargerCount}
          onChange={(value) => {
            setChargerDetails((prev) => ({
              ...prev,
              l2ChargerCount: value,
            }));
          }}
        ></InputNumber>
      </Form.Item>
        <Form.Item label="Level 3 Charger Count" name="l3ChargerCount"
          rules={[{ required: true, message: "Please input no.of l3 chargers!" }]}>
        <InputNumber
          // value={chargerDetails?.l3ChargerCount}    
            onChange={(value) => {
            setChargerDetails((prev) => ({
              ...prev,
              l3ChargerCount: value,
            }));
          }}
        ></InputNumber>
      </Form.Item>

      
        { chargerDetails.noOfChargers != getChargerCountFromMatrix()  ?
         <div className={`${Styles['count-unmatch-text']} ${Styles['full-width']}`}>
          <p><b>*</b>Charger count in Charger matrix doesn't match with total no.of chargers</p>
        </div> : <div className={`${Styles['count-match-text']} ${Styles['full-width']}`}><p><b>*</b>Charger count in matrix match with total no.of chargers</p></div>}




        {/* <Form.Item label="Connector matrix" name="connectorMatrix"> */}
          {/* <p> connector matrix input:</p> */}
          <div className={Styles['full-width']}>
            <table className={Styles['info-table']}>
              <thead>
                <tr>
                  <th>...</th>
                  <th>L2 Count</th>
                  <th>L3 Count</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Res Count</td>
                  <td>
                    <span>1 <FaPlug /> Chargers<InputNumber          
                    value={chargerDetails?.connectorMatrix?.[0]?.[0]?.[0]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[0]?.[0]) {
                              newMatrix[0][0][0] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span>
                    <span>2 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[0]?.[0]?.[1]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[0]?.[0]) {
                              newMatrix[0][0][1] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span>
                  </td>
                  <td><span>1 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[0]?.[1]?.[0]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[0]?.[1]) {
                              newMatrix[0][1][0] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span>
                    <span>2 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[0]?.[1]?.[1]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[0]?.[1]) {
                              newMatrix[0][1][1] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span></td>
                </tr>
                <tr>
                  <td>Non Res Count</td>
                  <td><span>1 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[1]?.[0]?.[0]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[1]?.[0]) {
                              newMatrix[1][0][0] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span>
                    <span>2 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[1]?.[0]?.[1]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[1]?.[0]) {
                              newMatrix[1][0][1] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span></td>
                  <td><span>1 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[1]?.[1]?.[0]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[1]?.[1]) {
                              newMatrix[1][1][0] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span>
                    <span>2 <FaPlug /> Chargers<InputNumber
                    value={chargerDetails?.connectorMatrix?.[1]?.[1]?.[1]}
                        onChange={(value) => {
                          setChargerDetails((prev) => {
                            const newMatrix = JSON.parse(JSON.stringify(prev.connectorMatrix));
                            if (newMatrix?.[1]?.[1]) {
                              newMatrix[1][1][1] = value;
                            }
                            return {
                              ...prev,
                              connectorMatrix: newMatrix,
                            };
                          });}}
                    ></InputNumber></span></td>
                </tr>
                {/* {chargerDetails?.connectorMatrix?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.type}</td>
                    <td>{item.count}</td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
      {/* </Form.Item> */}
      






        {isApprover  && isApproverView && <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(chargerDetails).filter((value) => value !== null)
                .length /
                Object.values(chargerDetails).length <
                1 || chargerDetails?.isSectionCompleted || chargerDetails.noOfChargers != getChargerCountFromMatrix()
            }
            onChange={(e) => {
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item> }
      </Form>
    </div>
  );
};
export default ChargerDetailsComponent;
